module.exports = __webpack_public_path__ + "img/stel-logo-black.16988de7.png";